import React from "react";
import {Dialog} from "src/components/dialogs/Dialog"
import { css } from "aphrodite-jss";
import { RequestState } from "src/models/RequestState";
import axios from "axios";
import { JsonConvert } from "json2typescript";
import { AuthorDetail } from "src/models/AuthorDetail";
import { styles } from "src/components/dialogs/AuthorDetailDialogStyles";
import { PublicationListItem, PublicationAuthor } from "../../models/PublicationListItem";
import { ListGroupItem } from 'reactstrap';
import { URLBuilder } from "src/core/URLBuilder";

interface IAuthorDetailDialogProps {
    isOpen: boolean;
    onClose: any;
    id: string;
}

class AuthorDetailDialogState {
    public readonly requestState: RequestState;
    public readonly data: AuthorDetail;
    public readonly error: string;

    constructor() {
        this.requestState = RequestState.NOT_ASKED;
        this.data = new AuthorDetail;
        this.error = "";
    }

}

export class AuthorDetailDialog extends React.Component<IAuthorDetailDialogProps, AuthorDetailDialogState>{
    

    constructor(props: IAuthorDetailDialogProps) {
        super(props);
        this.state = new AuthorDetailDialogState();
    }

    public async componentDidUpdate (prevProps: IAuthorDetailDialogProps) {
        if(this.props.isOpen !== prevProps.isOpen  && this.props.isOpen === true) {
            //fetch the data
            const id = this.props.id; 
            const url = URLBuilder.author_info(id); 
            axios.get(url).then((res)=> {
                if(res.status === 200){
                    try{
                        const jsonConvert = new JsonConvert();
                        const authorDetail = jsonConvert.deserialize(res.data, AuthorDetail);
                        const newState = {...this.state, requestState: RequestState.SUCCESS, data: authorDetail}
                        this.setState(newState)
                    }catch(error) {
                        const newState = {...this.state, requestState: RequestState.ERROR, error: error.toString()}
                        this.setState(newState)
                    }
                }else{
                    const error = res.statusText + ":" + res.data
                    const newState = {...this.state, requestState: RequestState.ERROR, error: error}
                    this.setState(newState)
                }    
            }).catch((err)=>{
                const error = err.toString();
                const newState = {...this.state, requestState: RequestState.ERROR, error: error}
                this.setState(newState)
            });
        }
    }

    public render() {
        let content;           
        if(this.state.requestState === RequestState.SUCCESS){
            content = (
                <div id="content" className={css(styles.content)}>
                    <a id="name" className={css(styles.name)} href={`#faculty/${this.props.id}/`} target="_" >
                        {this.state.data.last_name + ", " + this.state.data.first_name}
                    </a>
                    <div id="affiliation" className={css(styles.affiliation)}  >
                        {this.state.data.affiliation}
                    </div>
                    <div id="publications" className={css(styles.publicationContainer)}>
                        {this.state.data.publications.map(this.buildPublication)}
                    </div>
                </div>
            ); 
        }else if(this.state.requestState === RequestState.LOADING)  {
            content = (
                <div>
                    Loading
                </div>
            )
        }else if(this.state.requestState === RequestState.ERROR){
            content = (
                <div>
                    {this.state.error}
                </div>
            )
        }

        return (            
            <Dialog isOpen={this.props.isOpen} onClose={this.props.onClose} > 
                <div id="container" className={css(styles.container)}>
                    <React.Fragment>
                        {content}
                    </React.Fragment>
                </div>
            </Dialog>
        )
    }

    private buildPublication = (publication: PublicationListItem, index: number) => {
        return (
            <ListGroupItem key={index} >
                <div className={css(styles.publication)} >
                    <a className={css(styles.publicationTitle)} href={publication.scopus_self_link} target={"_"} >
                        {publication.title}
                    </a>
                    <div style={{ fontSize: "0.85em" }}>
                        {this.buildCoauthors(publication.authors)}
                    </div>
                    <div style={{ fontSize: "0.75em" }} >
                        {publication.source_name}, {publication.pub_date}
                    </div>
                </div>
            </ListGroupItem>
        )
    }

    private buildCoauthors(coauthors: PublicationAuthor[]): string {
        let data;
        if(coauthors.length > 10){
            data = coauthors.slice(0,10);
        }else{
            data = coauthors;
        }

        const combinedNames = data.map((author: PublicationAuthor)=>{
            return author.first_name + " " + author.last_name; 
        })

        const coauthor_str = combinedNames.join(", ")
        return coauthor_str;
    }



}


// WEBPACK FOOTER //
// ./src/components/dialogs/AuthorDetailDialog.tsx